import React, { useRef } from "react";
import MapComponent from "./MapComponent";
import VoiceButton from "./VoiceButton";
import "./App.css";

function App() {
  const mapRef = useRef();

  // Handler to execute map commands from API response
  const handleMapCommand = (commandObj) => {
    if (mapRef.current) {
      if (Array.isArray(commandObj)) {
        commandObj.forEach(cmd => mapRef.current.executeCommand(cmd));
      } else {
        mapRef.current.executeCommand(commandObj);
      }
    }
  };

  return (
    <div className="App">
      <MapComponent ref={mapRef} />
      <VoiceButton onCommand={handleMapCommand} />
    </div>
  );
}

export default App;
